export interface TaslResultType {
	ZipFileSize: number;
	ZipFileURL: string;
	MoreProgressURL: string;
	MoreProgressURLSign: string;
	PROGRESS: ResultArray;
	Message: string;
}

export interface ResultArray {
	LOGTIME: string;
	ROWNO: number;
	TASKID: string;
}
export class TaskState {
	// ä»»å¡å®æ
	complete = 'completed';
	// ä»»å¡è¿è¡ä¸­
	running = 'running';
	// ä»»å¡åºé
	error = 'error';
}
